<template>
    <section>
        <div class="left">
            <h2 v-translate>Podporované typy zařízení</h2>
        </div>

        <div class="right checkbox_group">
            <ul>
                <li v-for="deviceType in this.deviceTypes" :key="'device_type_' + deviceType.id">
                    <input v-model="entity.supported_id_device_types" :id="'dev_type_' + deviceType.id"
                           :disabled="!isEditable"
                           name="deviceTypes[]" type="checkbox" :value="deviceType.id"/>
                    <label :for="'dev_type_' + deviceType.id">{{ deviceType.name }}</label>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
import formFilterData from "@/components/mixins/form-filter-data"
import requiredFields from "@/components/mixins/required-fields"

export default {
    name: "SupportedDeviceTypes",
    mixins: [formFilterData, requiredFields],
    props: {
        entity: Object,
        isEditable: Boolean,
        deviceTypes: Array
    },
    methods: {
        validateFormRequiredFields() {

        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/forms/SupportedDeviceTypes.vue